import React, { useEffect } from 'react';
import { Phone, PhoneOff, Video } from 'lucide-react';
import { IncomingCallInfo, handleAvatarError } from '../types';
import { resolveAvatarUrl } from '../utils/serverUrl';
import { startRinging, stopRinging } from '../utils/ringtone';

interface IncomingCallBannerProps {
  callInfo: IncomingCallInfo;
  onAccept: () => void;
  onReject: () => void;
}

const IncomingCallBanner: React.FC<IncomingCallBannerProps> = ({ callInfo, onAccept, onReject }) => {
  // 벨소리는 공유 AudioContext가 담당한다 (utils/ringtone).
  // 여기서 컨텍스트를 새로 만들면 자동재생 정책상 suspended로 남아 무음이 된다 — 그 모듈 주석 참조.
  useEffect(() => {
    startRinging();
    return stopRinging;
  }, []);

  return (
    // top: PC앱 제목 표시줄(창 버튼) 아래로 — TitleBar의 --titlebar-h 주석
    <div className="fixed top-[calc(var(--titlebar-h,0px)+1rem)] right-4 z-50 flex items-center gap-4 bg-gray-900 text-white rounded-2xl shadow-2xl px-5 py-4 min-w-[320px] border border-gray-700 animate-slide-down">
      {/* 아바타 */}
      <div className="relative flex-shrink-0">
        <div className="w-12 h-12 rounded-full bg-brand-600 flex items-center justify-center text-lg font-bold">
          {callInfo.callerAvatar ? (
            <img src={resolveAvatarUrl(callInfo.callerAvatar)} onError={handleAvatarError} alt={callInfo.callerName} className="w-12 h-12 rounded-full object-cover" />
          ) : (
            callInfo.callerName.charAt(0)
          )}
        </div>
        <span className="absolute -bottom-1 -right-1 bg-green-500 rounded-full p-1">
          <Video size={10} />
        </span>
      </div>

      {/* 정보 */}
      <div className="flex-1 min-w-0">
        <p className="text-xs text-gray-400 mb-0.5">화상 통화 수신</p>
        <p className="font-semibold truncate">{callInfo.callerName}</p>
        <p className="text-xs text-gray-400 truncate">{callInfo.channelName}</p>
      </div>

      {/* 버튼 */}
      <div className="flex gap-2 flex-shrink-0">
        <button
          onClick={onReject}
          className="w-10 h-10 rounded-full bg-brand-600 hover:bg-brand-700 flex items-center justify-center transition-colors"
          title="거절"
        >
          <PhoneOff size={18} />
        </button>
        <button
          onClick={onAccept}
          className="w-10 h-10 rounded-full bg-green-600 hover:bg-green-500 flex items-center justify-center transition-colors"
          title="수락"
        >
          <Phone size={18} />
        </button>
      </div>
    </div>
  );
};

export default IncomingCallBanner;
